import React from 'react';
import {FileUpload} from '@mui/icons-material';
import ExpandableIconButtonComponent from '@components/buttons/ExpandableIconButton.component';

interface SelectFileButtonComponentProps {
  accept?: string;
  handleFileSelected?: (file: File) => void;
  title: string;
}

const SelectFileButton = (props: SelectFileButtonComponentProps) => {
  const {
    accept,
    handleFileSelected,
    title
  } = props;

  const inputFileRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <>
      <input
        type="file"
        accept={accept}
        ref={inputFileRef}
        style={{display: 'none'}}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (!file) return;

          handleFileSelected?.(file);
          e.currentTarget.value = '';
        }}/>
      <ExpandableIconButtonComponent variant="contained"
                                     color="primary"
                                     startIcon={<FileUpload/>}
                                     onClick={() => inputFileRef.current?.click()}
                                     title={title}
      />

    </>
  );
};

export default SelectFileButton;
